import PendoIcon from '../../icon/pendo-icon.vue.js';
import PendoMultiselectValue from '../pendo-multiselect-value.vue.js';
import PendoLoadingIndicator from '../../loading-indicator/pendo-loading-indicator.vue.js';
import { setStyles } from '../../../utils/dom.js';

var script = {
  name: 'PendoDataSourceTrigger',
  components: {
    PendoIcon,
    PendoLoadingIndicator,
    PendoMultiselectValue
  },
  inject: ['multiselect'],
  inheritAttrs: false,
  watch: {
    'multiselect.isOpen': function (isOpen) {
      if (isOpen) {
        this.$el.focus();
      }
    },
    'multiselect.maxTriggerWidth': function () {
      setStyles(this.$refs.trigger, {
        maxWidth: this.multiselect.maxTriggerWidth
      });
    }
  },
  mounted() {
    setStyles(this.$refs.trigger, {
      minWidth: this.multiselect.isFullWidth ? '100%' : 88,
      maxWidth: this.multiselect.maxTriggerWidth
    });
  }
};

export { script as default };
//# sourceMappingURL=pendo-data-source-trigger.vue2.js.map
